import React from 'react'
import type { IFinancingCallbackWrapperProps } from './types'
import './styles.scss'

export const FinancingCallbackWrapper = (props: IFinancingCallbackWrapperProps) => {
  const { children } = props

  return <section>{children}</section>
}
